import React, {useEffect, useState} from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import {Motion, spring} from 'react-motion';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import CustomerTableRowComponent, {TableCell} from '../components/customer/CustomerTableRowComponent';
import CustomerNameTableCell from '../components/customer/CustomerNameTableCell';
import CsvUploadFile from '../components/common/CsvUploadFile';
import SearchFieldComponent from '../components/common/SearchFieldComponent';
import Pagination from '../components/common/Pagination';
import CustomerDocumentTableCell from '../components/customer/CustomerDocumentTableCell';
import {uploadCsvFile} from '../api/network/csvService';
import {fetchCustomers, createCustomers, insertCustomers} from '../redux/actions/CustomersActions';
import {uploadCustomerCsv} from '../redux/actions/CsvActions';
import {
    filterCustomers,
    groupAndSortCustomersByAlphabet,
    mapBusinessCustomersToCustomers, mapCsvCustomerToState, mapCsvDataToBusinessCustomers,
    sortCustomers
} from '../utils/customersUtils';
import tableHeadingData from '../data/tableHeadings/customerTableHeading.json';
import {encryptData, groupAndSortItemsByField} from '../utils';
import ActionButton from '../components/common/Action Buttons/ActionButton';
import ActionButton2 from '../components/common/Action Buttons/ActionButton2';
import ActionButton3 from '../components/common/Action Buttons/ActionButton3';
import ActionButton4 from '../components/common/Action Buttons/ActionButton4';
import ActionButton5 from '../components/common/Action Buttons/ActionButton5';
import {profileSections} from './CustomerProfile';

import {ReactComponent as Loading} from '../assets/button-loader.svg';

// Styles
const CustomerPageWrapper = styled.div`
  //display: grid;
  //grid-template-columns: 42px 280px 280px 280px ;
  width: 100%;
  height: 91%;
  padding-bottom: 100px;
  padding-left: 32px;
  overflow-y: scroll;
  //grid-template-rows: 40px 60px;
  //grid-row-gap: 5px;
  //grid-template-columns: 100%;
`;

const PaginationWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 72px;
  bottom: 0;
  right: calc(-1 * var(--side-nav-width));
  background: var(--white);
  box-shadow: 0px -4px 6px rgba(0, 0, 0, 0.1), 0px -2px 4px rgba(0, 0, 0, 0.06);

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;

  padding-left: 32px;
  //margin-left: var(--side-nav-width);
`;

const ColumnHeading = styled.h4`
  font-size: var(--font-m);
  font-weight: 500;

  &:first-of-type {
    margin-left: var(--space-s1);
    grid-column-start: 1;
  }
`;

const SearchFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
`;

const ColumnHeadingsWrapper = styled.div`
  display: grid;
  grid-template-columns: 322px repeat(auto-fill, 276px);
  grid-auto-flow: column;
`;

/**
 *
 * @param user
 * @param customers
 * @param fetchCustomers
 * @param createCustomers
 * @param insertCustomers
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function Customers({
    user,
    customers,
    fetchCustomers,
    createCustomers,
    insertCustomers,
    ...props
}) {
    const history = useHistory();
    const tableHeadings = tableHeadingData;

    const companyId = (user && user.companyId) || '';

    const [isUploading, setIsUploading] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState([]);
    const [customerQuery, setCustomerQuery] = useState('');
    const [paginationPage, setPaginationPage] = useState(0);
    const [paginationRowsPerPage, setPaginationRowsPerPage] = useState(10);

    const [customerOnboardingLoading, setCustomerOnboardingLoading] = useState(false);

    useEffect(() => {
        if (companyId) fetchCustomers(companyId);
    }, [user]);

    const onSearchChange = e => {
        setCustomerQuery(e.target.value);
    };

    //TODO fix logic
    const onCustomerCheckboxSelected = (e, customer) => {
        const {checked} = e.target;
        // we're replacing the previous customer, otherwise, we're setting the selected customer back to null
        //onCustomerSelected(checked ? customer : null);

        // if (customer && customer.warning) return; // when customer has warning they can't be selected.
        setSelectedCustomer(checked ? customer : null);

        if (selectedCustomer.includes(customer.name)) {
            setSelectedCustomer([]);
        } else {
            setSelectedCustomer([
                customer.name
            ]);
        }
    };

    const handleOnPageChange = page => {
        setPaginationPage(page);
    };

    const handleOnRowsPerPageChange = rowsPerPage => {
        setPaginationRowsPerPage(rowsPerPage);
        setPaginationPage(0);
    };

    const handleOnFileUpload = e => {
        if (e) e.preventDefault();
        const file = e.target.files[0];
        console.log('File uploaded', file);
        const csvData = new FormData();
        csvData.append('file', file);

        setIsUploading(true);
        uploadCsvFile(csvData)
            .then(data => {
                const csvData = data;

                // update customer state
                const customer = mapCsvCustomerToState(data);
                insertCustomers(customer);

                // call create business customer
                const customersForCreation = mapCsvDataToBusinessCustomers(data);
                createCustomers(companyId, customersForCreation);
            })
            .catch(error => {

            });
    };

    const handleOnCustomerNameClick = customer => {
        // const slug = customer.id || customer.name; // TODO find a different var to use as slug

        console.log('customer name click: ', customer);
        history.push(`/company/customers/${customer.companyId}/${customer.id}`, {section: profileSections.Identity});

        // history.push(`customers/${slug}`);
    };

    /**
     *  Prepare the table cell data to be handed into the table Customers table.
     *
     *  The table cells are custom component. We create the table cell here
     *  so that we can handle any logic attached a table cell outside of the component
     */
    const addTableFieldsToCustomerData = (customerData, selectedCustomer) => customerData.map(customer => {
        const selectedCustomerId = (selectedCustomer) ? selectedCustomer.name : false;
        // TODO change to use the customer id
        const mode = (selectedCustomerId === customer.name) ? 'selected' : (selectedCustomerId) ? 'disabled' : 'default';

        return {
            ...customer,
            /**
             *  NB - the table cell need to have a key because they are going to used in a list.
             *  NB - the keys for `tableField` should map back to a key from the header data provided.
             */
            tableFields: {
                name: <CustomerNameTableCell
                    key={1}
                    customerName={customer.name}
                    mode={mode}
                    onCustomerNameClick={() => handleOnCustomerNameClick(customer)}
                    loading={customer.syncing}
                    warning={customer.warning}
                />,
                email: <TableCell key={2}>{customer.email}</TableCell>,
                company: <TableCell key={3}>{customer.company}</TableCell>,
                jobTitle: <TableCell key={4}>{customer.jobTitle}</TableCell>,
                letter: <CustomerDocumentTableCell key={5} hasDocument={true}/>
            }
        };
    });

    const checkCustomerForMissingDocs = customers => customers.map(customer => {
        const missingData = customer.warning;
        // check required params
        //TODO add check for relevant params;
        customer.warning = missingData;
        return customer;
    });

    const handleCustomerOnboardingClick = event => {
        if (event) event.preventDefault();

        setCustomerOnboardingLoading(true);

        setTimeout(async () => {
            try {
                // Prep Constants
                const selfOnboardingUrl = process.env.REACT_APP_SELF_ONBOARDING;
                const encryptedHost = await encryptData(window.location.href);

                const targetUrl = `${selfOnboardingUrl}/getting-started?eh=${encryptedHost}`;

                const win = window.open(targetUrl, '_self');
                win.focus();
            } catch (error) {
                console.error('encrypt.host.failed');
                setCustomerOnboardingLoading(false);
            }
        }, 2000);
    };

    /**
     *  The data flow is as follow for the customers:
     *
     *  1: add the table data to the table cell
     *  2: apply any filter that is given.
     *  3: check customer data for missing field and add warning.
     *  4. paginate customer data.
     *  5: Order the customer data.
     **/

    // Check for required params on customer data and add warning to those with missing requirements.
    const checkedCustomer = checkCustomerForMissingDocs(customers);

    // Add table cell components
    const customersWithTableFields = addTableFieldsToCustomerData(checkedCustomer, selectedCustomer);

    // Apply search filter
    let filteredCustomer = [...customersWithTableFields];
    if (customerQuery) filteredCustomer = filterCustomers(customerQuery, filteredCustomer);

    const sortedCustomer = sortCustomers(filteredCustomer);

    const start = paginationPage * paginationRowsPerPage;
    const end = (paginationPage + 1) * paginationRowsPerPage;
    const paginatedCustomerData = sortedCustomer.slice(start, end);

    // Order the table data.
    const orderedCustomerData = //groupAndSortCustomersByAlphabet(paginatedCustomerData);
        groupAndSortItemsByField(paginatedCustomerData, 'name');

    // Pagination functions and variables
    const paginationCount = filteredCustomer.length;

    return <CustomerPageWrapper>
        <SearchFieldWrapper>
            <SearchFieldComponent
                onSearchChange={onSearchChange}
                placeholder="Filter customer by name, email or company"
            />
            <CsvUploadFile onChange={handleOnFileUpload}/>

            <ActionButton5 onClick={handleCustomerOnboardingClick} disabled={customerOnboardingLoading}>
                {customerOnboardingLoading ? <Loading/> : 'Onboard Customer'}
            </ActionButton5>

        </SearchFieldWrapper>

        {/**
         *  Customers Table
         **/}
        <ColumnHeadingsWrapper>
            {tableHeadings.map(heading => <ColumnHeading key={heading.name}>{heading.name}</ColumnHeading>)}
        </ColumnHeadingsWrapper>

        {
            Object.keys(orderedCustomerData).map((heading, index) =>
                // each heading contains customers under that letter heading
                // eslint-disable-next-line implicit-arrow-linebreak
                (
                    <div key={index}>
                        <CustomerTableRowComponent
                            onCustomerCheckboxSelected={onCustomerCheckboxSelected}
                            rowHeading={heading}
                            selectedCustomers={selectedCustomer}
                            columnHeaders={tableHeadings}
                            rowData={orderedCustomerData[heading]}
                        />
                    </div>
                ))
        }

        {/**
         * Pagination Component
         **/}
        <Motion
            defaultStyle={{y: 200}}
            style={{y: spring(paginationCount >= 1 ? 0 : 200)}}
        >
            {
                style => (
                    <PaginationWrapper
                        style={{transform: `translateY(${style.y}px)`}}
                    >
                        <Pagination
                            count={paginationCount}
                            page={paginationPage}
                            rowsPerPage={paginationRowsPerPage}
                            onChangePage={handleOnPageChange}
                            onRowsPerPageChange={handleOnRowsPerPageChange}
                        />
                    </PaginationWrapper>
                )}
        </Motion>
    </CustomerPageWrapper>;
}

Customers.propTypes = {
    fetchCustomers: PropTypes.func.isRequired,
    uploadCustomerCsv: PropTypes.func.isRequired,
    customers: PropTypes.array.isRequired
};

const mapDispatcherToProps = {
    fetchCustomers,
    insertCustomers,
    uploadCustomerCsv,
    createCustomers
};

function mapStateToProps(state) {
    const customers = mapBusinessCustomersToCustomers(state.customers);
    return {
        customers,
        user: state.user
    };
}

export default connect(mapStateToProps, mapDispatcherToProps)(Customers);
